angular.module('FlexyBeautyApp.services')
    .factory('AppUrlConstant', [
        function () {
            return {
                APP_URL: {
                    PROD: {
                        BACKOFFICE: "https://app.kiute.com",
                        INVALID_BACKOFFICE_HOSTNAME: "app.flexybeauty.com",
                        INVALID_BACKOFFICE_COMPLET_URL: "https://app.flexybeauty.com",
                    },
                    QA: {
                        BACKOFFICE: "https://app-staging.kiute.com",
                        INVALID_BACKOFFICE_HOSTNAME: "app-staging.flexybeauty.com",
                        INVALID_BACKOFFICE_COMPLET_URL: "https://app-staging.flexybeauty.com"
                    }
                }
            };
        }])

    .factory('AppRedirectionFactory', ['AppUrlConstant', '$window', function (AppUrlConstant, $window) {
        return {
            needRedirectionAppUrl: function (location) {
                if (location.host() === AppUrlConstant.APP_URL.PROD.INVALID_BACKOFFICE_HOSTNAME ||
                    location.host() === AppUrlConstant.APP_URL.PROD.INVALID_BACKOFFICE_COMPLET_URL) {
                    $window.location.href = AppUrlConstant.APP_URL.PROD.BACKOFFICE + '/#' + location.path();
                } else if (location.host() === AppUrlConstant.APP_URL.QA.INVALID_BACKOFFICE_HOSTNAME ||
                    location.host() === AppUrlConstant.APP_URL.QA.INVALID_BACKOFFICE_COMPLET_URL) {
                    $window.location.href = AppUrlConstant.APP_URL.QA.BACKOFFICE + '/#' + location.path();
                }
            }
        };
    }]);



// WEBPACK FOOTER //
// ./js/constants/RedirectionConstants.js